<vdr-card
    [title]="'product-validation.title' | translate"
    [ngClass]="isProductOkay ? 'card card-ok' : 'card card-error'"
>
    <!-- Status geral -->
    <div class="status-header">
        <div class="status-left">
            <span [ngClass]="isProductOkay ? 'text-green' : 'text-red'">
                <strong>
                    {{
                        isProductOkay
                            ? ('product-validation.messages.success'
                              | translate)
                            : ('product-validation.messages.error' | translate)
                    }}
                </strong>
            </span>
        </div>
    </div>

    <!-- Lista de problemas - mesma abordagem do customer -->
    <div *ngIf="!isProductOkay" class="mt-3">
        <ul class="error-list">
            <!-- Exibe apenas os erros que não são relacionados aos details -->
            <li *ngFor="let err of getNonDetailErrors()" class="error-item">
                <span>
                    {{ getErrorTranslationKey(err.type) | translate }}
                </span>
                <span class="status-dot bg-red"></span>
            </li>

            <!-- Exibe os detalhes como itens da lista apenas quando houver problema -->
            <li *ngIf="!details.isActive" class="error-item">
                <span>
                    {{ 'product-validation.errors.inactive' | translate }}
                </span>
                <span class="status-dot bg-red"></span>
            </li>

            <li *ngIf="!details.hasPrice" class="error-item">
                <span>
                    {{ 'product-validation.errors.noPrice' | translate }}
                </span>
                <span class="status-dot bg-red"></span>
            </li>

            <li *ngIf="!details.hasStock" class="error-item">
                <span>
                    {{ 'product-validation.errors.noStock' | translate }}
                </span>
                <span class="status-dot bg-red"></span>
            </li>

            <li *ngIf="!details.hasMeasurementUnit" class="error-item">
                <span>
                    {{ 'product-validation.errors.noMeasurement' | translate }}
                </span>
                <span class="status-dot bg-red"></span>
            </li>
        </ul>
    </div>

    <!-- Detalhes do status (sempre mostra, mas com cores diferentes) -->
    <div class="status-details mt-3">
        <div class="detail-row" [ngClass]="{ 'error-bg': !details.isActive }">
            <span class="detail-label"
                >{{ 'product-validation.details.active' | translate }}:</span
            >
            <span>
                <span
                    class="status-dot"
                    [ngClass]="details.isActive ? 'bg-green' : 'bg-red'"
                ></span>
            </span>
        </div>

        <div class="detail-row" [ngClass]="{ 'error-bg': !details.hasPrice }">
            <span class="detail-label"
                >{{ 'product-validation.details.price' | translate }}:</span
            >
            <span>
                <span
                    class="status-dot"
                    [ngClass]="details.hasPrice ? 'bg-green' : 'bg-red'"
                ></span>
            </span>
        </div>

        <div class="detail-row" [ngClass]="{ 'error-bg': !details.hasStock }">
            <span class="detail-label"
                >{{ 'product-validation.details.stock' | translate }}:</span
            >
            <span>
                <span
                    class="status-dot"
                    [ngClass]="details.hasStock ? 'bg-green' : 'bg-red'"
                ></span>
            </span>
        </div>

        <div
            class="detail-row"
            [ngClass]="{ 'error-bg': !details.hasMeasurementUnit }"
        >
            <span class="detail-label"
                >{{
                    'product-validation.details.measurement' | translate
                }}:</span
            >
            <span>
                <span
                    class="status-dot"
                    [ngClass]="
                        details.hasMeasurementUnit ? 'bg-green' : 'bg-red'
                    "
                ></span>
            </span>
        </div>
    </div>
</vdr-card>
